import Actionbar from "src/components/common/actionbar/Authactionbar";

import { Content_SYS4090_R01 } from "./Content_SYS4090_R01";
import { SearchSection_SYS4090_R01 } from "./SearchSection_SYS4090_R01";
import { useSYS4090_R01Store } from "./Store_SYS4090_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { Table_SYS4090_R01 } from "./Table_SYS4090_R01";
import { useMouseContent } from "src/utils/mouse/mouseContent";
import { useEffect, useRef, useState } from "react";
import { Info_SYS4090_R01 } from "./Info_SYS4090_R01";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { AgGridReact } from "ag-grid-react";
import { SYS4090_R01Dto } from "./Dto_SYS4090_R01";

export const Container_SYS4090_R01 = () => {

	const { selectedSYS4090_R01, allCount } = useSYS4090_R01Store();

	const { setMessage } = useUiuxStore();

	
	
	const RESIZER = {
		code: 'SYS4090_R01',
		type: 'width',
		storageKey: 'SYS4090_R01-split-width',
		min: 5,
		max: 80,
		default: 72
	} as const;

	const gridRef = useRef<AgGridReact<SYS4090_R01Dto>>(null);
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const {
        handleExcelClick,
        fetchData,
		defaultSYS4090_R01Row,
		fetchOne,
        initContainerData,
        handleCreateClick,
        handleDeleteClick,
        handleSaveClick,
	} = Content_SYS4090_R01({
		gridRef,
		setMessage,
	});

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
//		minLeftWidth, maxLeftWidth,
		isResizing,
//		leftWidth, setLeftWidth,
		containerRef,
		infoRef
	});
	

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleCreateClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>

			<SearchSection_SYS4090_R01/>

			<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
				<div className="h-full" style={{ width: `${splitValue}%` }}>
					<Table_SYS4090_R01 gridRef={gridRef} defaultSYS4090_R01Row={defaultSYS4090_R01Row()} />
				</div>
				{/* 리사이저 */}
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
					// 드래그 시작 방지
					onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
				/>
				<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
					<Info_SYS4090_R01 defaultSYS4090_R01Row={defaultSYS4090_R01Row()} />
				</div>
			</div>
			<Message />
		</div>
	)
}